"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildRecordingTitle = exports.buildRecordingSubtitle = void 0; // TODO(maciejkowalski): move this logic to the transfrom-recording in hopin-web
// https://hopin.atlassian.net/browse/ST-688

var buildRecordingSubtitle = function buildRecordingSubtitle(_a) {
  var startedAt = _a.startedAt,
      endedAt = _a.endedAt,
      locale = _a.locale;

  if (!startedAt || !endedAt) {
    return '';
  }

  try {
    // TODO: replace with Intl.DateTimeFormat.formatRange once browser matrix supports
    var startDate = new Date(startedAt);
    var endDate = new Date(endedAt); // If event spans over multiple days show from and to date + time

    var showEndDay = endDate.getUTCDate() != startDate.getUTCDate();
    var StartFormat = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: 'numeric'
    });
    var EndFormat = void 0;

    if (showEndDay) {
      EndFormat = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric'
      });
    } else {
      EndFormat = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        minute: 'numeric'
      });
    }

    return "".concat(StartFormat.format(startDate), " - ").concat(EndFormat.format(endDate));
  } catch (error) {
    return '';
  }
};

exports.buildRecordingSubtitle = buildRecordingSubtitle;

var buildRecordingTitle = function buildRecordingTitle(_a) {
  var createdAt = _a.createdAt,
      locale = _a.locale,
      title = _a.title,
      startedAt = _a.startedAt,
      style = _a.style;
  if (title) return title;

  try {
    var date = new Date(startedAt || createdAt);
    var dateTimeFormat = new Intl.DateTimeFormat(locale, {
      dateStyle: style || 'long',
      timeStyle: 'short',
      hour12: true
    });
    return dateTimeFormat.format(date);
  } catch (err) {
    return '';
  }
};

exports.buildRecordingTitle = buildRecordingTitle;